export default `p++;
  float s=3.;
  float e=0.;
  for(int j=0;j++<12;p/=e)
    p=mod(p-1.,2.)-1.,
    p.xz*=rotate2D(PI/4.),
    e=dot(p,p)*.5,
    s/=max(e,0.001);
  return length(p.y)/max(s,0.001)-.7/max(s,0.001);
}`